module.exports = __webpack_public_path__ + "static/logo-571844736afc608a3c07d07ec137e538.png";